var $9fbc1ff7e87407ac$exports = {};
$9fbc1ff7e87407ac$exports = {
    "loading": `Caricamento...`,
    "placeholder": `Seleziona\u{2026}`
};


export {$9fbc1ff7e87407ac$exports as default};
//# sourceMappingURL=it-IT.module.js.map
